import { Link } from 'react-router-dom';
import { OrnateDivider, BananaLeaf } from '../components/KeralaDecor';
import './NotFoundPage.css';

export default function NotFoundPage() {
  return (
    <main className="nf">
      <BananaLeaf position="top-left" size={220} opacity={0.4} />
      <BananaLeaf position="bottom-right" size={220} opacity={0.4} mirror />
      <div className="container nf__inner">
        <span className="eyebrow-script">Hmm…</span>
        <h1>Page Not Found</h1>
        <OrnateDivider />
        <p>That dish isn't on our menu. Let's get you back to something tasty.</p>
        <div className="nf__cta">
          <Link to="/" className="btn btn-gold">Back to Home</Link>
          <Link to="/menu" className="btn btn-ghost btn-forest">View the Menu</Link>
        </div>
      </div>
    </main>
  );
}
